const errorMessages = {
	// Auth
	UNAUTHORIZED: 'You need to log in to continue.',
	TOKEN_EXPIRED: 'Your session has expired. Please log in again.',

	// Dataspace
	JOIN_TABLES_NO_MATCHES_FOUND:
		'No matching data found between your selected datasets. Please check your join configuration.',
	CREATE_DATASPACE_ERROR: 'There was an error creating the DataSpace. Please try again later.',
	UPDATE_DATASPACE_DATA_ERROR: 'There was an error updating the DataSpace data. Please try again later.',
	CLONE_DATASPACE_ERROR: 'There was an error cloning the DataSpace. Please try again later.',

	// Yahoo integration
	YAHOO_REFRESH_TOKEN_INVALID:
		'Your Yahoo connection has expired. Please reconnect your account using "Connect New Leagues" in the Create DataSpace form.',
	YAHOO_API_ERROR: "We couldn't connect to Yahoo. Please try again in a few minutes.",

	// Fantrax
	FANTASY_LEAGUES_UPDATE_FAILED: 'There was an error updating your leagues. Please try again later.',

	// General
	NETWORK_ERROR: "We couldn't reach the server. Check your internet connection.",
	UNKNOWN_ERROR: 'Something went wrong. Please try again.',
};

// Converts backend error into user-friendly text
export function getUserMessage(error) {
	// Handle cases where fetch fails entirely (no response)
	if (!error) return errorMessages.UNKNOWN_ERROR;

	// Network or CORS failure (no response body)
	if (error.name === 'TypeError' && error.message.includes('fetch')) {
		return errorMessages.NETWORK_ERROR;
	}

	// Backend-defined error with code + optional defaultMessage
	return errorMessages[error.response?.data?.code] || error.defaultMessage || errorMessages.UNKNOWN_ERROR;
}

export default getUserMessage;
